import { render, staticRenderFns } from "./copyRight.vue?vue&type=template&id=22f187ce&scoped=true&"
import script from "./copyRight.vue?vue&type=script&lang=js&"
export * from "./copyRight.vue?vue&type=script&lang=js&"
import style0 from "./copyRight.vue?vue&type=style&index=0&id=22f187ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f187ce",
  null
  
)

export default component.exports